import { render } from "./PAddPhotos.vue?vue&type=template&id=561e60cc"
import script from "./PAddPhotos.vue?vue&type=script&lang=js"
export * from "./PAddPhotos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__